var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresentation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 498.199,
    height: 314.313,
    viewBox: "0 0 498.199 314.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ilustra\\xE7\\xE3o",
    transform: "translate(-627.14 -336.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M1151.246,452.006l-43.1,50.506-87.8,102.883-52.418,61.42-45.766-4.08-93.51-8.342-45.51-4.064L966.451,435.52Z",
    transform: "translate(-27.407 -17.374)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M807.256,655.117,979.3,454.928l163.58,14.7",
    transform: "translate(-31.644 -20.784)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_15",
    "data-name": "Caminho 15",
    d: "M1153.242,513.005l-87.8,102.883a67.669,67.669,0,1,1,87.8-102.883Z",
    transform: "translate(-72.507 -27.863)",
    fill: "#de4e8b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33",
    transform: "translate(811.339 336.627)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_53",
    "data-name": "Ret\\xE2ngulo 53",
    width: 72.589,
    height: 6.152,
    transform: "translate(0 29.643) rotate(-24.102)",
    fill: "#ff5051"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_54",
    "data-name": "Ret\\xE2ngulo 54",
    width: 72.589,
    height: 6.152,
    transform: "translate(6.029 43.12) rotate(-24.102)",
    fill: "#ff5051"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_55",
    "data-name": "Ret\\xE2ngulo 55",
    width: 72.589,
    height: 6.152,
    transform: "translate(12.058 56.596) rotate(-24.102)",
    fill: "#ff5051"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_56",
    "data-name": "Ret\\xE2ngulo 56",
    width: 50.372,
    height: 6.152,
    transform: "translate(18.087 70.073) rotate(-24.102)",
    fill: "#ff5051"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linha_3",
    "data-name": "Linha 3",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(939.208 418.456)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_4",
    "data-name": "Linha 4",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(945.036 419.069)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_5",
    "data-name": "Linha 5",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(950.864 419.662)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_6",
    "data-name": "Linha 6",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(956.691 420.255)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_7",
    "data-name": "Linha 7",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(962.519 420.848)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_8",
    "data-name": "Linha 8",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(968.347 421.441)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_9",
    "data-name": "Linha 9",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(974.174 422.034)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_10",
    "data-name": "Linha 10",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(980.002 422.627)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_11",
    "data-name": "Linha 11",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(985.83 423.22)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_12",
    "data-name": "Linha 12",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(991.657 423.813)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_13",
    "data-name": "Linha 13",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(997.485 424.406)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_14",
    "data-name": "Linha 14",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1003.313 424.999)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_15",
    "data-name": "Linha 15",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1009.141 424.768)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_16",
    "data-name": "Linha 16",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1014.968 425.361)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_17",
    "data-name": "Linha 17",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1020.796 425.954)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_18",
    "data-name": "Linha 18",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1026.624 426.547)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_19",
    "data-name": "Linha 19",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1032.451 427.14)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_20",
    "data-name": "Linha 20",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1038.279 427.733)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_21",
    "data-name": "Linha 21",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1044.107 427.502)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_22",
    "data-name": "Linha 22",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1049.935 428.095)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_23",
    "data-name": "Linha 23",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1055.762 428.688)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_24",
    "data-name": "Linha 24",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1061.59 429.281)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_25",
    "data-name": "Linha 25",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1067.418 429.874)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_26",
    "data-name": "Linha 26",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1073.245 430.467)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_27",
    "data-name": "Linha 27",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1079.073 431.06)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_28",
    "data-name": "Linha 28",
    x2: 7.835,
    y2: 14.551,
    transform: "translate(1085.349 431.66)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_29",
    "data-name": "Linha 29",
    x2: 8.048,
    y2: 14.946,
    transform: "translate(1090.964 431.858)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_30",
    "data-name": "Linha 30",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1096.556 432.607)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_31",
    "data-name": "Linha 31",
    x2: 8.283,
    y2: 15.383,
    transform: "translate(1102.384 433.2)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_32",
    "data-name": "Linha 32",
    x2: 5.931,
    y2: 11.015,
    transform: "translate(1108.212 433.793)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_33",
    "data-name": "Linha 33",
    x2: 3.671,
    y2: 6.818,
    transform: "translate(1114.039 434.386)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_34",
    "data-name": "Linha 34",
    x2: 0.816,
    y2: 1.516,
    transform: "translate(1119.867 434.487)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 1.84,
    cy: 1.84,
    r: 1.84,
    transform: "translate(952.525 449.558)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    cx: 4.141,
    cy: 4.141,
    r: 4.141,
    transform: "translate(951.604 473.482)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 2.3,
    cy: 2.3,
    r: 2.3,
    transform: "translate(901.916 513.969)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    cx: 3.681,
    cy: 3.681,
    r: 3.681,
    transform: "translate(865.109 558.137)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    cx: 5.061,
    cy: 5.061,
    r: 5.061,
    transform: "translate(926.76 613.347)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_6",
    "data-name": "Elipse 6",
    cx: 2.76,
    cy: 2.76,
    r: 2.76,
    transform: "translate(936.882 573.78)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_7",
    "data-name": "Elipse 7",
    cx: 3.681,
    cy: 3.681,
    r: 3.681,
    transform: "translate(1079.507 450.478)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_8",
    "data-name": "Elipse 8",
    cx: 1.84,
    cy: 1.84,
    r: 1.84,
    transform: "translate(1013.256 454.159)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9",
    "data-name": "Elipse 9",
    cx: 2.3,
    cy: 2.3,
    r: 2.3,
    transform: "translate(832.903 599.545)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_10",
    "data-name": "Elipse 10",
    cx: 2.76,
    cy: 2.76,
    r: 2.76,
    transform: "translate(804.378 618.868)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_11",
    "data-name": "Elipse 11",
    cx: 3.681,
    cy: 3.681,
    r: 3.681,
    transform: "translate(878.912 629.91)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_12",
    "data-name": "Elipse 12",
    cx: 3.221,
    cy: 3.221,
    r: 3.221,
    transform: "translate(901.916 551.696)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_13",
    "data-name": "Elipse 13",
    cx: 2.3,
    cy: 2.3,
    r: 2.3,
    transform: "translate(873.391 520.411)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_14",
    "data-name": "Elipse 14",
    cx: 4.141,
    cy: 4.141,
    r: 4.141,
    transform: "translate(972.768 597.704)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_15",
    "data-name": "Elipse 15",
    cx: 4.141,
    cy: 4.141,
    r: 4.141,
    transform: "translate(948.844 510.289)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_16",
    "data-name": "Elipse 16",
    cx: 28.297,
    cy: 28.297,
    r: 28.297,
    transform: "translate(963.653 393.542)",
    fill: "#faa741"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_17",
    "data-name": "Elipse 17",
    cx: 15.374,
    cy: 15.374,
    r: 15.374,
    transform: "translate(710.827 374.722)",
    fill: "none",
    stroke: "#292929",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35",
    transform: "translate(643.24 410.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_57",
    "data-name": "Ret\\xE2ngulo 57",
    width: 160.499,
    height: 22.554,
    transform: "translate(0.068 42.014) rotate(-15.175)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_58",
    "data-name": "Ret\\xE2ngulo 58",
    width: 154.262,
    height: 22.554,
    transform: "translate(89.619 22.54) rotate(74.825)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_59",
    "data-name": "Ret\\xE2ngulo 59",
    width: 71.56,
    height: 22.554,
    transform: "translate(153.522 164.54) rotate(164.825)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M807.12,449.01,819.6,474.973l23.286-6.316-13.052-42.11Z",
    transform: "translate(-674.86 -426.547)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M677.621,485.447l2.352,28.709-23.286,6.316-10.015-42.934Z",
    transform: "translate(-646.672 -435.505)",
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_60",
    "data-name": "Ret\\xE2ngulo 60",
    width: 34.506,
    height: 34.506,
    transform: "translate(181.371 123.236) rotate(-15.175)",
    fill: "#7459a6"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_61",
    "data-name": "Ret\\xE2ngulo 61",
    width: 10.122,
    height: 10.122,
    transform: "matrix(0.964, 0.267, -0.267, 0.964, 784.552, 508.822)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_62",
    "data-name": "Ret\\xE2ngulo 62",
    width: 7.361,
    height: 7.361,
    transform: "translate(627.922 417.602) rotate(6.096)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_63",
    "data-name": "Ret\\xE2ngulo 63",
    width: 18.403,
    height: 18.403,
    transform: "translate(654.211 539.794) rotate(-21.632)",
    fill: "#fdbd00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M898.062,464.66c16.132,13.141,37.168-11.792,50.685-.781s-9.749,29.776,3.767,40.786,20.037-11.241,27.886-4.848-1.031,17.293,5.945,22.976",
    transform: "translate(-47.597 -21.848)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M846.666,505.979c21.443,10.71,38.811-22.613,56.777-13.639s-3.462,35.925,14.5,44.9,19.693-17.681,30.124-12.47,3.2,19.7,12.468,24.33",
    transform: "translate(-38.567 -27.084)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_35",
    "data-name": "Linha 35",
    x1: 179.549,
    y2: 210.318,
    transform: "translate(760.955 422.737)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_36",
    "data-name": "Linha 36",
    x1: 176.3,
    y2: 206.513,
    transform: "translate(765.953 426.94)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_37",
    "data-name": "Linha 37",
    x1: 173.113,
    y2: 202.78,
    transform: "translate(771.17 431.214)",
    fill: "none",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_16",
    "data-name": "Caminho 16",
    d: "M931.86,642.06v56.96l-93.51-8.342V642.06Z",
    transform: "translate(-37.106 -55.035)",
    fill: "#faa741"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.876baecaacf7a8f1378f8152fe1c3b76.svg";
export { ForwardRef as ReactComponent };